"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getStaticNodes_1 = __importDefault(require("./getStaticNodes"));
var decomposePath_1 = __importDefault(require("./decomposePath"));
function updateTriggers(db, path) {
    var parts = (0, decomposePath_1.default)(path);
    var nodes = (0, getStaticNodes_1.default)(db, path);
    parts.forEach(function (x) {
        if (db.dynamic.fns[x]) {
            var n = (0, getStaticNodes_1.default)(db, x);
            nodes = nodes.concat(n);
        }
    });
    nodes.forEach(function (x) {
        //@ts-ignore
        if (!db.updates.triggers[x]) {
            //@ts-ignore
            db.updates.triggers[x] = [path];
            //@ts-ignore
        }
        else if (db.updates.triggers[x].indexOf(path) === -1) {
            //@ts-ignore
            db.updates.triggers[x].push(path);
        }
    });
    parts.forEach(function (y) {
        if (!db.updates.triggers[y]) {
            db.updates.triggers[y] = [path];
        }
        else if (db.updates.triggers[y].indexOf(path) === -1) {
            db.updates.triggers[y].push(path);
        }
    });
}
exports.default = updateTriggers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBkYXRlVHJpZ2dlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vdXBkYXRlVHJpZ2dlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxvRUFBOEM7QUFDOUMsa0VBQTRDO0FBRTVDLFNBQVMsY0FBYyxDQUFDLEVBQUUsRUFBRSxJQUFJO0lBQzlCLElBQUksS0FBSyxHQUFHLElBQUEsdUJBQWEsRUFBQyxJQUFJLENBQUMsQ0FBQztJQUNoQyxJQUFJLEtBQUssR0FBRyxJQUFBLHdCQUFjLEVBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUFDO0lBRXJDLEtBQUssQ0FBQyxPQUFPLENBQUMsVUFBQyxDQUFDO1FBQ2QsSUFBSSxFQUFFLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNyQixJQUFJLENBQUMsR0FBRyxJQUFBLHdCQUFjLEVBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQzlCLEtBQUssR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO1NBQ3pCO0lBQ0gsQ0FBQyxDQUFDLENBQUM7SUFFSCxLQUFLLENBQUMsT0FBTyxDQUFDLFVBQUMsQ0FBQztRQUNkLFlBQVk7UUFDWixJQUFJLENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDM0IsWUFBWTtZQUNaLEVBQUUsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDaEMsWUFBWTtTQUNiO2FBQU0sSUFBSSxFQUFFLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUU7WUFDdEQsWUFBWTtZQUNaLEVBQUUsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUNuQztJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsS0FBSyxDQUFDLE9BQU8sQ0FBQyxVQUFDLENBQUM7UUFDZCxJQUFJLENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDM0IsRUFBRSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUNqQzthQUFNLElBQUksRUFBRSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFO1lBQ3RELEVBQUUsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUNuQztJQUNILENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQUVELGtCQUFlLGNBQWMsQ0FBQyJ9